import {useFormikContext} from 'formik';
import {useEffect} from 'react';
import {registerSteps} from '../SignIn';

const FormikContext = ({handleSubmit, steps}) => {
  const {values} = useFormikContext();
  useEffect(() => {
    if (values.code?.length === 4 && steps === registerSteps.login) {
      handleSubmit(values);
    }
  }, [values.code?.length]);
  return null;
};

export default FormikContext;
